<!--
 * @Author: wzc
 * @Date: 2021-01-25 16:17:37
 * @LastEditors: wzc
 * @LastEditTime: 2021-07-01 17:01:33
-->
<template>
  <div class="page-loading-container flex-v">
    <div class="error-logo"></div>
    <div class="title wc100 alCenter mixtmt_font_14px" v-text="text"></div>
    <div
      class="retry-btn flex-v alCenter mixtmt_font_13px"
      @click="$emit('error_refresh')"
      v-if="has_refresh"
      v-text="refresh_text"
    ></div>
  </div>
</template>
<script>
export default {
  name: 'error_page',
  props: {
    text: {
      type: String,
    },
    refresh_text: {
      type: String,
      default: '服务异常，请稍后再试',
    },
    has_refresh: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    if (window.mixtmtBase_eventBus) {
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    }
  },
}
</script>
<style lang="scss">
.page-loading-container {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 100;
  width: 100%;
  height: auto;
  color: #b3b3b3;
  font-size: 14px;
  transform: translate(-50%, -50%);
  .error-logo {
    margin-left: auto;
    margin-right: auto;
    width: 512px;
    height: 465px;
    background-image: url(../../assets/images/404.png);
    background-size: auto 100%;
    object-fit: contain;
  }
  .retry-btn {
    margin-left: auto;
    margin-right: auto;
    width: auto;
    height: auto;
    padding-bottom: 100px;
    /* border-radius: 29px; */
    text-align: center;
    line-height: 1;
    /* background: linear-gradient(
      135deg,
      rgba(115, 205, 252, 1) 0%,
      rgba(0, 155, 255, 1) 100%
    ); */
    color: rgba(60, 60, 60, 0.45);
  }
}
</style>
